<template>
    <transition name="cz2__fade">
        <alert-modal
            v-if="mouseLeaveModalShown"
            :title="$t('MOUSE_LEAVE_MODAL_TITLE')"
            :superTitle="$t('MOUSE_LEAVE_MODAL_SUPER')"
            @close="close"
            data-cz-component="mouseLeaveModal"
            class="cz2__mouse-leave-modal"
        >
            <div class="cz2__modal-popup__copy">
                {{ $t('MOUSE_LEAVE_MODAL_COPY') }}
            </div>

            <div class="cz2__modal-popup__buttons">
                <btn
                    primary
                    narrow
                    @click="close"
                >
                    {{ $t('MOUSE_LEAVE_MODAL_PRIMARY') }}
                </btn>
            </div>
        </alert-modal>
    </transition>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__mouse-leave-modal {
            .cz2__modal-popup__copy {
                margin-bottom: 24px;
            }

            .cz2__modal-popup__buttons {
                padding-bottom: 8px;
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;

                .cz2__btn {
                    height: 40px;
                    width: 100%;
                    font-size: 16px;

                    &:focus {
                        &:before {
                            // Prevent focus styles from showing unwanted scrollbars
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    import AlertModal from './ui/AlertModal.vue';

    import Btn from './ui/Btn.vue';

    export default {
        components: {
            AlertModal,
            Btn,
        },

        computed: {
            mouseLeaveModalShown() {
                return this.$store.state.mouseLeaveModalShown;
            },

            mouseLeaveModalWasShown() {
                return this.$store.state.mouseLeaveModalWasShown;
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            isStarted() {
                return this.$store.getters.isStarted;
            },

            globalSettings() {
                return this.$store.state.customizer.globalSettings?.blueprint?.custom;
            },

            browserControlsModalEnabled() {
                return this.globalSettings?.['fun-browser-controls-modal-enabled'] === 'true';
            },
        },

        mounted() {
            window.addEventListener('popstate', this.showMouseLeaveModal);
            document.addEventListener('mouseleave', this.showMouseLeaveModal);
        },

        beforeDestroy() {
            this.removeListeners();
        },

        methods: {
            showMouseLeaveModal(event) {
                if (this.browserControlsModalEnabled && this.isStarted && !this.isKiosk && !this.mouseLeaveModalWasShown) {
                    if (event.type === 'popstate') {
                        // Push the current URL back into the stack, "trapping" user on the current page
                        window.history.pushState(null, document.title, window.location.href);
                    }

                    this.$store.dispatch('showMouseLeaveModal', true);
                    this.$store.dispatch('setMouseLeaveModalWasShown', true);
                }
            },

            close() {
                this.$store.dispatch('showMouseLeaveModal', false);
                this.removeListeners();
            },

            removeListeners() {
                window.removeEventListener('popstate', this.showMouseLeaveModal);
                document.removeEventListener('mouseleave', this.showMouseLeaveModal);
            },
        },
    };
</script>
